import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from '../axiosService/apiCall';
import { ToastContainer, toast } from "react-toastify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { ImBubbles3 } from "react-icons/im";
import { Modal, Button } from "react-bootstrap";


function Withdrawrequest() {
  const [data, setData] = useState([]);
  const [loadingId, setLoadingId] = useState({ id: null, action: null });
  // const [isLoading, setIsLoading] = useState(false);

  const [filterStatus, setFilterStatus] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [copiedValue, setCopiedValue] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");

  const handleOpenModal = (reason) => {
    // console.log("reason", reason);

    setSelectedReason(reason);
  };
  const userData = async () => {
    try {
      let params = { url: `getwithdrawRequest`, method: 'GET' };
      let response = await makeApiRequest(params);
      if (response.status) {
        setData(response.data);
        setFilteredData(response.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
    } catch (error) {
      // console.log('error', error);
    }
  };

  const approvalData = async (id, status) => {
    setLoadingId({ id, action: status }); // Set loading state for the clicked row
    setApprovalStatus(status);

    try {
      const swalResult = await Swal.fire({
        title: status === "approve" ? "Are you sure you want to Approve Withdrawrequest?" : "Are you sure you want to Reject Withdrawrequest?",
        icon: "question",
        iconHtml: "?",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCancelButton: true,
        showCloseButton: true,
        ...(status === "reject" && {
          html:
            '<label for="swal-input" style="margin-top: 10px;">Enter reason for rejection</label>' +
            '<input id="swal-input" class="swal2-input input-reason" placeholder="Reason" maxlength="255">',
          preConfirm: () => {
            const rejectionReason = document.getElementById("swal-input").value;
            if (!rejectionReason.trim()) {
              Swal.showValidationMessage("Please provide a reason for rejection");
              return false;
            }
            return rejectionReason;
          },
        }),
      });

      if (swalResult.isConfirmed) {
        let payload = {
          type: status,
          id: id,
        };

        if (status === "reject") {
          payload.reason = swalResult.value;
        }

        let params = {
          url: `adminwithdrawaction`,
          method: "POST",
          data: payload,
        };

        const response = await makeApiRequest(params);

        if (response.status) {
          toast.success(response.message || `Withdraw request ${status}ed successfully`);

          // Optimistically update the local data
          setData(prev =>
            prev.map(item =>
              item.withdrawHistory._id === id
                ? {
                  ...item,
                  withdrawHistory: {
                    ...item.withdrawHistory,
                    status: status === 'approve' ? 2 : 3,
                    Rejectreason: status === 'reject' ? swalResult.value : item.withdrawHistory.Rejectreason
                  }
                }
                : item
            )
          );

          setLoadingId({ id: null, action: null }); // Reset loading state
          userData();
        } else {
          toast.warning(response.message);
          setLoadingId({ id: null, action: null });
        }

        // if (response.status) {
        //   toast.success(response.message || `Withdraw request ${status}ed successfully`);
        //   setTimeout(() => {
        //     userData();
        //     setLoadingId({ id: null, action: null }); // Reset loading state
        //   }, 2000);
        // } else {
        //   toast.warning(response.message);
        //   setLoadingId({ id: null, action: null });
        // }
      } else {
        setLoadingId({ id: null, action: null }); // Reset loading state if action is canceled
      }
    } catch (error) {
      // console.log("error", error);
      setLoadingId({ id: null, action: null });
    }
  };



  useEffect(() => {
    userData();
  }, []);


  useEffect(() => {
    let filtered = data;

    if (filterStatus !== null) {
      filtered = filtered.filter(item => item.withdrawHistory.status === filterStatus);
    }

    if (searchQuery) {
      filtered = filtered.filter(item => {
        const withdrawDate = new Date(item.withdrawHistory.WithDrawReqTime).toLocaleDateString("en-IN");
        const searchQueryLower = searchQuery.toLowerCase();

        return (
          item.email.toLowerCase().includes(searchQueryLower) ||
          item.withdrawHistory.toAddress.toLowerCase().includes(searchQueryLower) ||
          withdrawDate.includes(searchQueryLower)
        );
      });
    }

    setFilteredData(filtered);
  }, [filterStatus, searchQuery, data]);


  const compressString = (str) => {
    return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
  };
  const handleCopy = (value) => {
    setCopiedValue(value);
    setTimeout(() => setCopiedValue(''), 2000);
  };
  const columns = [
    {
      name: 'S.No', width: '80px', selector: (row, index) => index + 1 + (currentPage - 1) * rowsPerPage
      , sortable: true
    },
    {
      name: 'Request Date',
      selector: row => new Date(row.withdrawHistory.WithDrawReqTime).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
      sortable: true,
      width: "200px"
    },
    {
      name: 'Approval or Reject Date',
      selector: row =>
        row.withdrawHistory?.WithDrawApprovalorRejectTime
          ? new Date(row.withdrawHistory.WithDrawApprovalorRejectTime)
            .toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
          : "Not Available",
      sortable: true,
      width: "250px"
    },

    { name: 'Type', width: "200px", selector: (row) => row.withdrawHistory.type, sortable: true },

    ,
    { name: 'Email', width: "350px", selector: (row) => row.email, sortable: true },


    // { name: 'To Address', width: '150px', selector: (row) => row.withdrawHistory.toAddress, sortable: true },
    {
      name: 'To Address',
      width: '150px',
      selector: (row) => row.withdrawHistory.toAddress,
      cell: (row) => (
        <div className="no-wrap-cell">
          {compressString(row.withdrawHistory.toAddress)}
          <CopyToClipboard className="ms-2" text={row.withdrawHistory.toAddress} onCopy={() => handleCopy(row.withdrawHistory.toAddress)}>
            <FontAwesomeIcon icon={faCopy} />
          </CopyToClipboard>
        </div>
      ),
    },
    { name: 'Coin', selector: (row) => "TEXA", sortable: true },
    {
      name: 'Total Amount',
      selector: row => row.withdrawHistory.originalAmount,
      sortable: true,
      width: "150px"
    },
    { name: 'Transaction Amount', selector: (row) => row.withdrawHistory.amount, sortable: true, width: "200px" },
    {
      name: 'Commission Fee',
      selector: row => row.withdrawHistory.adminCommissionFee
      ,
      sortable: true,
      width: "180px"
    },
    {
      name: 'Reject Reason',

      selector: row => <div className='d-flex'>
        {row.withdrawHistory.Rejectreason
          ? row.withdrawHistory.Rejectreason.substring(0, 20) + "..."
          : "N/A"
        }
        {row.withdrawHistory.Rejectreason
          ? <p type="button" className='ms-2' data-bs-toggle="modal" data-bs-target="#rejectReasonModal"
            onClick={() => handleOpenModal(row.withdrawHistory.Rejectreason)}>
            <ImBubbles3 />
          </p>
          : ""
        }


        <div className="modal fade" id="rejectReasonModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="rejectReasonLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="rejectReasonLabel">Reject Reason</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body" style={{ wordWrap: "break-word", overflowWrap: "break-word", whiteSpace: "normal" }}>
                {selectedReason || "No reason provided"}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>,

      sortable: true,
      width: "200px"

    },
    {
      name: 'Action',
      cell: (row) => {
        console.log("row", row);

        const isLoading = loadingId.id === row.withdrawHistory._id;
        const status = row.withdrawHistory.status;

        return (
          <div className='d-flex align-items-center gap-3'>
            {isLoading ? (
              <span className="loader">Processing...</span>
            ) : (
              <>
                {status === 1 && !isLoading && (
                  <>
                    <button
                      className='Aproved'
                      disabled={isLoading}
                      onClick={() => approvalData(row.withdrawHistory._id, 'approve')}
                    >
                      Approve
                    </button>
                    <button
                      className='reject'
                      disabled={isLoading}
                      onClick={() => approvalData(row.withdrawHistory._id, 'reject')}
                    >
                      Reject
                    </button>
                  </>
                )}
                {status === 2 && (
                  <button className='Aproved' disabled>Approved</button>
                )}
                {status === 3 && (
                  <button className='reject' disabled>Rejected</button>
                )}
              </>
            )}
          </div>
        );
      },
      width: "200px"
    }


    // {
    //   name: 'Action',
    //   cell: (row) => (
    //     <div className='d-flex align-items-center gap-3'>
    //       {loadingId.id === row.withdrawHistory._id ? (
    //         <span className="loader">Processing...</span>
    //       ) : (
    //         <>
    //           {row.withdrawHistory.status === 1 && (
    //             <>
    //               <button
    //                 className='Aproved'
    //                 disabled={loadingId.id === row.withdrawHistory._id}
    //                 onClick={() => approvalData(row.withdrawHistory._id, 'approve')}
    //               >
    //                 {loadingId.id === row.withdrawHistory._id ? "Processing..." : "Approve"}
    //               </button>
    //               <button
    //                 className='reject'
    //                 disabled={loadingId.id === row.withdrawHistory._id}
    //                 onClick={() => approvalData(row.withdrawHistory._id, 'reject')}
    //               >
    //                 {loadingId.id === row.withdrawHistory._id ? "Processing..." : "Reject"}
    //               </button>
    //             </>
    //           )}
    //           {row.withdrawHistory.status === 2 && <button className='Aproved' disabled>Approved</button>}
    //           {row.withdrawHistory.status === 3 && <button className='reject' disabled>Rejected</button>}
    //         </>
    //       )}
    //     </div>
    //   ),
    //   width: "200px"
    // }


  ];


  return (
    <div className='App'>
      <ToastContainer />
      <div className='container'>
        <div className='custom-saled-order text-dark ms-3'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className="py-3 d-flex justify-content-between">
                <h3 className="component-user">Withdraw Request</h3>
              </div>
              <div className='row'>
                <div className='col-lg-6'>
                  <input
                    className="form-control form-search"
                    type="text"
                    placeholder="Search by Email or Address"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div className='col-lg-3'>
                  <div className="mb-3">
                    <select
                      className="form-select form-search"
                      value={filterStatus ?? ''}
                      onChange={(e) => setFilterStatus(e.target.value ? Number(e.target.value) : null)}
                    >
                      <option value="">All</option>
                      <option value="1">Pending</option>
                      <option value="2">Approved</option>
                      <option value="3">Rejected</option>
                    </select>
                  </div>
                </div>
              </div>

              {copiedValue && <div className="alert alert-success">Copied: {copiedValue}</div>}
              {/* Table */}
              <div className='row'>
                <div className='col-lg-12'>
                  <div className='custom-datascroll'>
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      pagination
                      highlightOnHover
                      dense
                      // noDataComponent="No records found"
                      persistTableHead={true}
                      paginationPerPage={rowsPerPage}
                      paginationRowsPerPageOptions={[10, 20, 30, 50]}
                      onChangePage={(page) => setCurrentPage(page)}
                      onChangeRowsPerPage={(newRowsPerPage, page) => {
                        setRowsPerPage(newRowsPerPage);
                        setCurrentPage(page);
                      }}
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Withdrawrequest;
